import VericalList from "component/list/Vertical";
import CommonGamesList from "component/list/CommonGames";
import GamesList from "component/list/Games";
import CategoryGames from "component/list/CategoryGames";
import TableList from "component/list/TableList";
import FilterList from "component/list/FilterList";

export { VericalList };
export { CommonGamesList };
export { GamesList };
export { CategoryGames };
export { TableList };
export { FilterList };

export default Object.assign({
  VericalList,
  CommonGamesList,
  GamesList,
  CategoryGames,
  TableList,
  FilterList,
});
